// extracted by mini-css-extract-plugin
export default {"card":"StatCard_card__SrZqn","clickable":"StatCard_clickable__KCFM8","chevron":"StatCard_chevron__aC32k","button":"StatCard_button__LryL+","accent":"StatCard_accent__iPE70"};